export const homeConstants = {
  EDITBOARD_OPEN: 'EDITBOARD_OPEN',
  EDITBOARD_CLOSE: 'EDITBOARD_OPEN',
  TASKDIALOG_OPEN: 'TASKDIALOG_OPEN',
  TASKDIALOG_SELECT: 'TASKDIALOG_SELECT',
  UPLOAD_TASKDIALOG_OPEN: 'UPLOAD_TASKDIALOG_OPEN',
  UPLOAD_TASKDIALOG_CLOSED: 'UPLOAD_TASKDIALOG_CLOSED',
  ADD_PROJECT_DIALOG: 'ADD_PROJECT_DIALOG',
  EDIT_PROJECT_DIALOG: 'EDIT_PROJECT_DIALOG',
  TASKDIALOG_CLOSE: 'TASKDIALOG_CLOSE',
  INVITEDIALOG_OPEN: 'INVITEDIALOG_OPEN',
  INVITEDIALOG_CLOSE: 'INVITEDIALOG_CLOSE',
  MOREMENU_OPEN: 'MOREMENU_OPEN',
  MOREMENU_CLOSE: 'MOREMENU_CLOSE',
  READRECEIPT_OPEN: 'READRECEIPT_OPEN',
  READRECEIPT_CLOSE: 'READRECEIPT_CLOSE',
  IMPORT_SCHEDULE_OPEN: 'IMPORT_SCHEDULE_OPEN',
  IMPORT_SCHEDULE_CLOSED: 'IMPORT_SCHEDULE_CLOSED',
  SUBDIALOG_OPEN: 'SUBDIALOG_OPEN',
  SUBDIALOG_CLOSE: 'SUBDIALOG_CLOSE',
  SAMPLE_PROJECT_DIALOG_OPEN: 'SAMPLE_PROJECT_DIALOG_OPEN',
  SAMPLE_PROJECT_DIALOG_CLOSE: 'SAMPLE_PROJECT_DIALOG_CLOSE',
  IS_LOADING: 'IS_LOADING',
  NOT_LOADING: 'NOT_LOADING',
  OPEN_USER_EDIT_DRAWER: 'OPEN_USER_EDIT_DRAWER',
  CLOSE_USER_EDIT_DRAWER: 'CLOSE_USER_EDIT_DRAWER',
  STATUSCHANGEDIALOG_OPEN: 'STATUSCHANGEDIALOG_OPEN',
  STATUSCHANGEDIALOG_CLOSE: 'STATUSCHANGEDIALOG_CLOSE',
  CIRCULAR_PROGRESS_LOADING_OPEN: 'CIRCULAR_PROGRESS_LOADING_OPEN',
  CIRCULAR_PROGRESS_LOADING_CLOSE: 'CIRCULAR_PROGRESS_LOADING_CLOSE'
};



// WEBPACK FOOTER //
// ./src/constants/home.constants.js